<div ngbDropdown [class.dropdown-toggle-none]="!showToggle">
  <button class="btn btn-select {{extraClasses}}"
          [class.dropdown-toggle]="showToggle"
          [disabled]="disabled"
          type="button"
          [class.selected]="selectedItem && selectedItem.value && !selectedItem.isDefaultValue"
          ngbDropdownToggle>
    <span *ngIf="!selectedItem || !selectedItem.value">{{placeholder}}</span>
    <span *ngIf="selectedItem && selectedItem.value">{{selectedItem.label}}</span>
  </button>
  <div ngbDropdownMenu aria-labelledby="dropdownConfig">
    <button class="dropdown-item"
            *ngFor="let item of items"
            (click)="model = item; modelChange.emit(item)">
      {{item.label}}
    </button>
  </div>
</div>